<template lang="pug">
  md-dialog(:md-active.sync="showDialog" v-on:md-closed="clearForm")
    md-dialog-title Fund Request
    .md-layout
      .md-layout-item.md-size-100
        md-table
          md-table-row
            md-table-cell Name
            md-table-cell {{name}}
          md-table-row
            md-table-cell Email
            md-table-cell {{email}}
          md-table-row
            md-table-cell Taken Analyst Group
            md-table-cell {{ag_taken}}
          md-table-row
            md-table-cell Analyst Group Leaders
            md-table-cell {{sa_names}}          
      .md-layout-item.md-size-100(style="margin-top: 20px;")
        p Please provide a brief message to the member why you are declining (N/A if approving):
      .md-layout-item.md-size-100
        md-field
          md-input(type="text" v-model="reason")
      .md-layout-item.md-size-100
        p(v-if="error" style="color: red") {{error}}
    md-dialog-actions
      md-button.md-success(@click="approveRequest()") Approve
      md-button.md-danger(@click="rejectRequest()") Decline

</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      name: null,
      email: null,
      ag_taken: null,
      sa_names: null,
      request_id: null,
      reason: null,
      error: null,
      showDialog: null,
    }
  },
  props: {
    groupID: {
      type: Number,
      default: null
    }
  },
  created() {
    this.$bus.$on('request:view', (request) => {
      this.name = request.member.full_name;
      this.email = request.member.email;
      this.ag_taken = request.ag_taken ? 'Yes' : 'No';
      this.sa_names = request.sa_names;
      this.request_id = request.id;
      this.showDialog = true;
    })
  },
  methods: {
    approveRequest() {
      axios.post(`/api/org/fund_requests/${this.request_id}/approve_join`, {})
      .then((res) => {
        this.$bus.$emit('fund:refresh');
        this.showDialog = false;
      }).catch(() => {
        this.error = 'Sorry, there was an error. Please try again later.';
      })
    },
    rejectRequest() {
      if (this.reason == null || this.reason.length <= 2) {
        this.error = 'Please provide an apt reason for declining this request.'
      } else {
        axios.post(`/api/org/fund_requests/${this.request_id}/reject_join`, {'message': this.reason})
        .then((res) => {
          this.$bus.$emit('fund:refresh');
          this.showDialog = false;
        }).catch(() => {
          this.error = 'Sorry, there was an error. Please try again later.';
        })
      }
    },
    clearForm() {
      this.name = null;
      this.email = null;
      this.ag_taken = null;
      this.sa = null;
      this.request_id = null;
      this.reason = null;
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/Fund/FundRequestsForm.vue